import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetCertificados = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/cuestionarios/${params.id}?parte=${params.parte}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getCertificadosMutation: mutation.mutate,
    };
}